export const insightQueryKeys = {
  root: (orgId: string) => ['insights', 'root', orgId] as const,
  folders: () => ['insights', 'folders'] as const,
  documents: () => ['insights', 'documents'] as const,
  // Nested under `documents()` so every list invalidation also
  // refreshes the open document.
  document: (documentId: string) =>
    [...insightQueryKeys.documents(), documentId] as const,
  archived: () => ['insights', 'archived'] as const,
  documentUrl: (documentId: string) =>
    ['insights', 'document-url', documentId] as const,
  search: (query: string) => ['insights', 'search', query] as const,
  // Prefix that matches every cached quick-search term;
  // invalidate it wherever `documents()` is, so a row the
  // bar caches can't outlive the document it points at.
  quickSearchAll: () => ['insights', 'quick-search'] as const,
  quickSearch: (query: string) =>
    [...insightQueryKeys.quickSearchAll(), query] as const,
  // Prefix that matches every data-table query regardless of org/params;
  // invalidate it wherever `documents()` is invalidated to keep the List
  // view in sync with the folder tree.
  dataTableAll: () => ['insights', 'data-table'] as const,
  dataTable: (params: unknown, orgId: string | undefined) =>
    [...insightQueryKeys.dataTableAll(), orgId, params] as const,
  processingQueue: () => ['insights', 'processing-queue'] as const,
  conversionProgress: (dealId: string) =>
    ['insights', 'conversion-progress', dealId] as const,
};
